import PropTypes from "prop-types"

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "components/ui/carousel"
import Media from "components/ui/media"

const FAQCarousel = ({ questions }) => {
  return (
    <Media className="mx-16 mb-48" lessThan="tablet">
      <Carousel aria-label="Klarna FAQ">
        <CarouselContent>
          {questions.map((q, i) => (
            <CarouselItem className="px-40 text-center" key={i}>
              {q}
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="inline-flex" />
        <CarouselNext className="inline-flex" />
      </Carousel>
    </Media>
  )
}
FAQCarousel.propTypes = {
  questions: PropTypes.array,
}
export default FAQCarousel
